import React, { useEffect, useState } from 'react';
import { Helmet } from "react-helmet";
import Header from "../../../componentes/header/header";
import FinalComponent from "../../../componentes/EndPage/Final";
import homeData from './traducao.json';

const Contatos = () => {
    const [language, setLanguage] = useState(localStorage.getItem("siteLanguage") || "pt");
    const [translation, setTranslation] = useState(homeData[language] || homeData["pt"]);

    const handleLanguageChange = (newLang) => {
        setLanguage(newLang);
        localStorage.setItem("siteLanguage", newLang);
        window.location.reload();
    };

    useEffect(() => {
        const browserLanguage = navigator.language.split('-')[0];
        if (!localStorage.getItem("siteLanguage")) {
            localStorage.setItem("siteLanguage", browserLanguage);
            setLanguage(browserLanguage);
            setTranslation(homeData[browserLanguage] || homeData["pt"]);
        }
    }, []);

    useEffect(() => {
        setTranslation(homeData[language] || homeData["pt"]);
    }, [language]);

    const generoClass = "text-[30px] text-[#B040B1] mt-0 inline-block relative font-extrabold max-[1500px]:mt-[8%] max-[1024px]:mt-[15%] max-[768px]:text-[24px] max-[768px]:mt-[25%] max-[480px]:mt-[40%]";
    const generoAfter = (
      <span
        className="absolute left-[-50%] bottom-[-1px] w-[200%] h-[45px] z-[-20] rounded-[50px] shadow-[5px_5px_10px_rgba(0,0,0,0.2)] max-[768px]:left-[-10%] max-[768px]:w-[120%] max-[768px]:h-[35px]"
        style={{
          background: "linear-gradient(to right, rgba(106, 13, 173, 0.4), rgba(255, 102, 178, 0.4))"
        }}
        aria-hidden="true"
      />
    );

    return (
        <>
            
            <Helmet>
                 <title>{translation.page_title || 'Contatos | Sobrevidas ACS'}</title>
            </Helmet>
            <Header handleLanguageChange={handleLanguageChange} />   

            <div className="flex justify-center w-full">
                <h2
                    className="
                        text-[30px] text-[#B040B1] font-black relative inline-block
                        mt-[0vh]
                        max-[1424px]:mt-[12vh] max-[1024px]:mt-[14vh] max-[768px]:mt-[18vh] max-[480px]:mt-[20vh]
                        text-center
                    "
                >
                    {translation.contacts || 'Contatos'}
                    <span
                        className="
                            absolute bottom-[-1px] left-[-55%] w-[200%] h-[45px]
                            bg-gradient-to-r from-[rgba(106,13,173,0.4)] to-[rgba(255,102,178,0.4)]
                            shadow-[5px_5px_10px_rgba(0,0,0,0.2)] -z-20 rounded-[50px]
                        "
                        aria-hidden="true"
                    />
                </h2>
            </div>

            <div className="flex justify-center items-start gap-[100px] my-[5%] max-[1024px]:flex-col max-[1024px]:items-center max-[1024px]:gap-[20px] max-[768px]:my-[5%]">
                <div className="text-left pl-[30px] flex-1 max-w-[500px]">
                    <div className="text-[#C85B5C] font-semibold text-[40px] mb-[10px]">
                        <p>{translation.social_media || 'Redes Sociais'}</p>
                    </div>
                    <div className="text-[20px] font-medium mb-[30px]">
                        <p>Facebook:</p>
                        <p>Instagram:</p>
                    </div>
                    <div className="text-[#C85B5C] text-[40px] font-semibold mb-[10px]">
                        <p>{translation.cgis_ufg || 'CGIS UFG'}</p>
                    </div>
                    <div className="text-[20px] font-medium">
                        <p>{translation.email || 'Email: saude.ufg@gmail.com'}</p>
                        <p>{translation.address || 'Sala da CGIS-UFG: 1° andar, prédio do SIASS-UFG'}</p>
                    </div>
                </div>
                <iframe
                    className="flex-1 max-w-[700px] h-[450px] shadow-[5px_5px_10px_rgba(0,0,0,0.5)] max-[1024px]:w-[80%] max-[1024px]:h-[350px] max-[768px]:h-[250px] max-[480px]:h-[200px]"
                    title="localização"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1911.0260890581799!2d-49.24401996741441!3d-16.674272194440146!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935ef1b761c84859%3A0x5ba43e7f92e683b3!2sCGIS!5e0!3m2!1spt-BR!2sbr!4v1737577875858!5m2!1spt-BR!2sbr"
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                />
            </div>
            <div className="mt-[2em] max-[768px]:mt-[5em]">
                <FinalComponent />
            </div>
        </>
    );
};

export default Contatos;
